import { render, staticRenderFns } from "./website-services.vue?vue&type=template&id=9147fd76&scoped=true&"
import script from "./website-services.vue?vue&type=script&lang=js&"
export * from "./website-services.vue?vue&type=script&lang=js&"
import style0 from "./website-services.vue?vue&type=style&index=0&id=9147fd76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9147fd76",
  null
  
)

export default component.exports